@if (leadMagnet) {
    <div class="background">
        @if (!error && !success) {
            <div class="max-w-sm">
                <form [formGroup]="leadMagnetForm" class="light">
                    <div class="w-full pb-4">
                        <label for="firstName" class="hidden">
                            First Name
                        </label>
                        <input
                            class="font-sm font-darkgrey rounded-md !bg-white px-4 py-2 font-heading"
                            id="firstName"
                            name="firstName"
                            formControlName="firstName"
                            type="text"
                            placeholder="First Name"
                            data-testid="leadMagnetFirstName"
                            style="border: 1px solid #c8c8c8" />
                    </div>
                    <div class="w-full pb-4">
                        <label for="email" class="hidden">
                            Email address
                        </label>
                        <input
                            class="rounded-md !bg-white px-4 py-2"
                            id="email"
                            name="email"
                            formControlName="email"
                            type="text"
                            placeholder="Email"
                            data-testid="leadMagnetEmail"
                            style="border: 1px solid #c8c8c8" />
                    </div>

                    <div class="md:justify-start">
                        <app-save-button
                            [showLoader]="showLoader"
                            [success]="success"
                            [disabled]="
                                !(leadMagnetForm.valid && leadMagnetForm.dirty)
                            "
                            (onClick)="onSubmit()"
                            [additionalClasses]="[
                                '!bg-red disabled:!bg-red disabled:shadow-none',
                                'w-full py-2 px-2 md:w-2/3 shadow-md !border-none md:px-0',
                            ]"
                            data-testid="leadMagnetSubmit">
                            {{ leadMagnet.callToAction }}
                        </app-save-button>
                    </div>
                </form>
            </div>
        }
        @if (success) {
            <div class="mt-4">
                <div class="pb-4">
                    <p
                        class="text-xl font-semibold"
                        data-testid="leadMagnetSuccessTitle">
                        Thank you!
                    </p>
                    <p class="pb-2 text-deemphasized">
                        Please check your email
                    </p>
                </div>
            </div>
        }
        @if (error) {
            <div class="mt-4 pb-4">
                <p class="text-xl font-semibold">There was an error 😢</p>
                <p class="pb-2">
                    There was an error processing your request. Please try again
                    at a later time.
                </p>
                <p>
                    If it is an urgent request, feel free to reach out to
                    <a href="mailto:travel@followalice.com">
                        travel&#64;followalice.com </a
                    >.
                </p>
            </div>
        }
    </div>
}
